import React, { createContext, useState  } from "react";
import { auth  , signInWithEmailAndPassword  , onAuthStateChanged  , db , query ,collection , where , getDocs , signOut } from "../firebase";
import { useContext } from "react";
import { AppContext } from "./AppContext";
import { useNavigate } from "react-router-dom";

export const AuthenticationContext = createContext();

export const AuthContextProvider = ({ children }) => {

 
  
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const [success , setSuccess ] = useState(false);

  const {completed} = useContext(AppContext);
  const [completedVal , setCompletedVal ] = completed;

  const {emailFirst} = useContext(AppContext);
  const [emailFirstVal , setEmailFirstVal ] = emailFirst;
 

  onAuthStateChanged(auth, (usr) => {
    if (usr) {
      setUser(usr);
      setLoading(false);
    } else {
      setLoading(false);
    }
  });

  const onLogin = async (email, password) => {
   
  
    setLoading(true);

    const q = query(collection(db, "users"), where("email", "==", email ) );
   
    const querySnapshot = await getDocs(q);
  
    const usersDataArray = querySnapshot.docs ? querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })) : '';

    if (email === ''  ) {
        setError('يرجى ادخال ايميل المستخدم')
    }

    if (password === ''  ) {
            setError('يرجى ادخال كلمة مرور المستخدم')
    }

setTimeout(() => {
  setLoading(false);
  setError('');
} , 1500)

   
    if ( email !== '' && password !== '' ) {
      signInWithEmailAndPassword(auth, email, password)
      .then((u) => {
        setUser(u);

        if ( usersDataArray.length !== 0  ) {
          let objectUser = {
            id: usersDataArray[0].id ? usersDataArray[0].id : '',
            name: usersDataArray[0].fullName ? usersDataArray[0].fullName : '' ,
            phoneNumber: usersDataArray[0].phoneNumber ? usersDataArray[0].phoneNumber : '',
            country: usersDataArray[0].country ? usersDataArray[0].country : '',
            email: usersDataArray[0].email ? usersDataArray[0].email : '',
          }
         localStorage.setItem("thousand_miles_user",JSON.stringify(objectUser));
         setCompletedVal(false);
         setEmailFirstVal('');
         
         return true;

        }
        else {
          setCompletedVal(true);
          setEmailFirstVal(email);
          return false;
          
        }
     
              setSuccess(true);
              setLoading(false);
         
      }) .catch(() => {
    
       
          setError('فشل تسجيل الدخول يرجى التحقق من بياناتك');
             setLoading(false);
      });
    }
    else {
      setTimeout(() => {
        setError('خطأ في تسجيل الدخول');
        setSuccess(false);
        setLoading(false);
      
      } , 2500)
    }
    
  };
  const onLogout = () => {
    signOut(auth).then(() => {
      localStorage.removeItem("thousand_miles_user");
      setUser(null);
      setError(null);
    });
  };
 

  return (
    <AuthenticationContext.Provider
    value={{
        isAuthenticated: !!user,
        user,
        loading,
        success,
        error,
        onLogin,
        onLogout
      }}
    >
      {children}
    </AuthenticationContext.Provider>
  );
};
